import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { api } from '@share/config/api.config';
import { environment } from 'src/environments/environment';
import { CreateEventRequest } from '@share/requests/create-event.request';
import { handleHttpError } from '@share/utils/http-error.utils';
import { BlockEvent } from '@share/models/block-event';
import { ExitEventRequest } from '@share/requests/exit-event.request';
import { UpdateEventRequest } from '@share/requests/update-event.request';

@Injectable({
  providedIn: 'root',
})
export class EventService {

  // Injects
  private readonly httpClient = inject(HttpClient);


  public listBlockEvents(): Observable<BlockEvent[]> {

    const resource = `${environment.acreageApiUrl}/${api.v1.events}`;

    return this.httpClient.get<BlockEvent[]>(resource).pipe(handleHttpError());
  }

  
  public getEventById(id: number): Observable<BlockEvent | null> {

    const resource = `${environment.acreageApiUrl}/${api.v1.events}/${id}`;

    return this.httpClient.get<BlockEvent>(resource).pipe(handleHttpError());
  }


  public createEvent(newEvent: CreateEventRequest): Observable<BlockEvent> {

    const resource = `${environment.acreageApiUrl}/${api.v1.events}`;

    return this.httpClient.post<BlockEvent>(resource, newEvent).pipe(handleHttpError());
  }


  public createExitEvent(exitEvent: ExitEventRequest): Observable<BlockEvent> {

    const resource = `${environment.acreageApiUrl}/${api.v1.events}/exit`;

    return this.httpClient.post<BlockEvent>(resource, exitEvent).pipe(handleHttpError());
  }


  public deleteEvent(id: number): Observable<object> {

    const resource = `${environment.acreageApiUrl}/${api.v1.events}/${id}`;

    return this.httpClient.delete(resource).pipe(handleHttpError());
  }


  public updateEvent(updateEvent: UpdateEventRequest): Observable<BlockEvent> {

    const resource = `${environment.acreageApiUrl}/${api.v1.events}/update`;

    return this.httpClient.post<BlockEvent>(resource, updateEvent).pipe(handleHttpError());
  }

}
